import { useLocation } from "wouter";
import { useActiveJobs } from "@/hooks/use-active-jobs";

/**
 * JobBadge — red counter rendered over the VP logo when background generations
 * are running. Click returns the user to the exact view that is generating
 * (the job's denormalized deepLink).
 */
export function JobBadge(): JSX.Element | null {
  const { jobs, count } = useActiveJobs();
  const [, navigate] = useLocation();
  if (count === 0) return null;
  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        navigate(jobs[0].deepLink);
      }}
      title={`${count} ${count === 1 ? "generowanie w toku" : "generowania w toku"} — kliknij, by wrócić`}
      className="absolute -top-1.5 -right-1.5 z-10 min-w-[18px] h-[18px] px-1 rounded-full bg-[#ef3e29] text-white text-[10px] font-bold flex items-center justify-center ring-2 ring-black/50 animate-pulse cursor-pointer"
    >
      {count > 9 ? "9+" : count}
    </button>
  );
}
